import React from 'react'
import { Link } from 'react-router-dom'

const products = [
    { id: "01", title: "Bluetooth earphones", icon: "flaticon-right-arrow-1", data: "A personal portfolio is a collection of your work, achievements, and skills that highlight your abilities and professionalism." },
    { id: "02", title: "Smart home devices", icon: "flaticon-up-right-arrow", data: "A personal portfolio is a collection of your work, achievements, and skills that highlight your abilities and professionalism." },
    { id: "03", title: "External hard drives", icon: "flaticon-right-arrow-1", data: "A personal portfolio is a collection of your work, achievements, and skills that highlight your abilities and professionalism." }
];

const Success = () => {
    return (
        <>
            <section
                id="career-success"
                className="career-success-main-block affiliate-table"
            >
                <div className="container">
                    <div className="career-success-block">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-8">
                                <h2 className="career-heading">
                                    Dare To Dream Big, Succeed In Your Career!
                                </h2>
                            </div>
                            <div className="col-lg-6 col-md-4 text-start text-md-end text-lg-end">
                                <Link to="/Aboutus" title="" className="btn btn-primary">
                                    Read more <i className="flaticon-right-arrows" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {products.map((product) => (
                                <div className="career-success-table" key={product.id}>
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <h3 className="career-success-title">
                                                <span>{product.id}</span>{product.title}
                                            </h3>
                                        </div>
                                        <div className="col-lg-4">
                                            <p>
                                                {product.data}
                                            </p>
                                        </div>
                                        <div className="col-lg-3">
                                            <i className={product.icon} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Success
